'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactTracking = require('react-tracking');

var _reactTracking2 = _interopRequireDefault(_reactTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   Import this in a top-level component that wraps all tracking events.
   Export the Component as follows:
   *******************************************************
     export default initializeTracking(handler)(MyTopLevelComponent)
   *******************************************************
   handler is your function that will handle all incoming tracking data
*/
var initializeTracking = function initializeTracking(handler) {
  return (0, _reactTracking2.default)({}, { dispatch: function dispatch(data) {
      return handler(data);
    } });
};

exports.default = initializeTracking;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/InitializeTracking.js
// module id = 924
// module chunks = 48 49 50